import { combineReducers } from 'redux';

import applicationPermissions from './applicationPermissions';
import companyUsers from './companyUsers';

const rootUserManagementReducer = combineReducers({
  applicationPermissions,
  companyUsers,
});

export default rootUserManagementReducer;
